import { useState, useEffect, type Key } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Select, Space, Spin, Table as AntTable, Tabs, Tag, InputNumber } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import DataType from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box, Grid, TextField, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import { apiEndpoints } from '../../../config';
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MComptesRegroup';
import Demande from '../../../Models/McomptesPretEtDecouvert';
import Demande2 from '../../../Models/MComptesOperatSysteme';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import  { ColumnsType } from 'antd/es/table';
import DataPeriod1 from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataPeriod2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import CompteRegroupe from "../../../Models/CompteRegroup";
//import { IconButton, InputAdornment, Paper,  TablePagination, TableRow,TableBody, TableCell, TableContainer, TableHead } from '@mui/material';
import { IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import BlockIcon from '@mui/icons-material/Block';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CheckIcon from '@mui/icons-material/Check';
//import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";
import { Check, CheckCircle } from "@mui/icons-material";
//import McomptesCommis from "../../../Models/MComptesCommis";
import McomptesOperatsysteme from "../../../Models/MComptesOperatSysteme";
import McomptesOperatSysteme from "../../../Models/MComptesOperatSysteme";


//pour les commis
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

//pour les codes operation (nouveau flow comptes contrepartie)
let searchOperatGen: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const ComptesOperatSysteme = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [DataBranch, SetDataBranch] = useState<McomptesOperatSysteme[]>([]);
          const [currentDataBranch, setCurrentDataBranch] = useState<McomptesOperatSysteme | null>(null);
            
        const [searchTerm, setSearchTerm] = useState('');
            const [page, setPage] = useState(0); // Page actuelle
             const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
            const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
            const [choix, setChoix] = useState('I');
        
    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Compte de regroupement", value: "PLANCP" },
        { label: " Compte intérêts et commission", value: "IC" },
        { label: " Compte de prêts", value: "TYPEPRET" },
        { label: " Compte produit opération", value: "OPERAT" }
    ]

    //pour la selection de la table
    //let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: Ttable, Colonne1: Nnum, Colonne2: Colon, Colagence: '101', Choix: 22 }
    let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '', Choix: 22 }


    // DECLARATION DES COLONNES DU TABLEAU
    const columns1: ColumnsType<DataType> = [
        {
            title: 'Idplan',
            dataIndex: 'Idplan',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.cptregpt)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.NUMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCLI)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.SERVGE)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'codage',
            dataIndex: 'codage',
        },
        {
            title: 'cptregpt',
            dataIndex: 'cptregpt',
        }
    ];




    function Getselectcli() {
        setData([])
        form.setFieldValue("idplan", "")
        form.setFieldValue("lib_idplan", "")
            SetTtable("PLANCP")
            SetNnum("IDPLAN")
            setColon("LIBELL")
            setColumn(columns1)

        // if (form.getFieldValue("categorie") == "PLANCP") {

        //     SetTtable("PLANCP")
        //     SetNnum("IDPLAN")
        //     setColon("LIBELL")
        //     setColumn(columns1)

        // } else if (form.getFieldValue("categorie") == "IC") {
        //     SetTtable("COMMIS")
        //     SetNnum("CODCOM")
        //     setColon("LIBELL")
        //     setColumn(columns2)
        // } else if (form.getFieldValue("categorie") == "TYPEPRET") {
        //     SetTtable("TYPEPRET")
        //     SetNnum("TYPEPRET")
        //     setColon("LIBELLE")
        //     setColumn(columns3)
        // } else if (form.getFieldValue("categorie") == "OPERAT") {
        //     SetTtable("OPERAT")
        //     SetNnum("CODOPE")
        //     setColon("LIBELL")
        //     setColumn(columns4)
        // } else {
        //     SetTtable("")
        //     SetNnum("")
        //     setColumn("")
        // }
    }

       // Fonction pour convertir un objet avec des clés en majuscules
   
    // 📄 Filtrage des données en fonction du terme de recherche
      const filteredDataBranch = DataBranch.filter((item) =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      // 📄 Pagination après filtrage
      const paginatedDataBranch = filteredDataBranch.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
    // --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
      const handleOpenDialog = (DataToEdit: McomptesOperatSysteme | null = null) => {
   //alert('modification'+DataToEdit?.UTILIS)
        if (DataToEdit) {
          setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
          
          form.setFieldsValue({...DataToEdit})
          setChoix('U')
         // HandleModif()
         // console.log(DataToEdit)
        } else {
       
        }
       // setOpenDialog(true);
       // setDialogError(null); // Réinitialiser les erreurs du dialogue
      };

      // --- valide un enregistrement ---
      const handleValidate = (DataToEdit: McomptesOperatsysteme | null = null) => {
       setChoix('V')
       if (DataToEdit) { 
        setCurrentDataBranch({ ...DataToEdit })
       form.setFieldsValue({...DataToEdit})
      }; // Copie pour l'édition}
      
        if (currentDataBranch?.UTIVAL=== null || currentDataBranch?.UTIVAL=== undefined || currentDataBranch?.UTIVAL==="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
         var comptesCommis: McomptesOperatSysteme = {
    IDCODOPE: currentDataBranch?.IDCODOPE || 0,
    CODOPE: currentDataBranch?.CODOPE || '',
    NUMCPT: currentDataBranch?.NUMCPT || '',
    
    CODAGE: currentDataBranch?.CODAGE || '',
    LIBELL: currentDataBranch?.LIBELL || '',
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: Perss.coduti,
    DATVAL: Perss.datjour,
    CHOIX: 'V',

            // CodCom: currentDataBranch?.CodCom ||0,
            // idplan: currentDataBranch?.IDPLAN || '',
            // codage:  currentDataBranch?.CODAGE || '',
            // cptregpt : currentDataBranch?.CPTREGPT || '',
            // utilis: currentDataBranch?.UTILIS || '',
            // utival: Perss.coduti || '',
            // datval:Perss.datjour,
            // choix : "V",
            // codcom:"",
            // libelle:currentDataBranch?.NOMCPT || '',
            // nomcpt:"",
            // datcre:currentDataBranch?.DATCRE.toString() || new Date().toDateString(),
         };
       // alert('validation'+DataToEdit?.UTIVAL)
        // alert('validation'+DataToEdit?.UTIVAL)
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        //  CompteReg.choix = choix;
                     
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
       
          let data = Crypter.encrypt(JSON.stringify(comptesCommis));
         if (window.confirm("Confirmer la validation de ce compte de groupe?")) {
         
            //  alert("yeteooo aaa")
            // alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptOperat,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                loadAllDataBranch()                 
            SweetAlert.fire({})
        // Action de validation ici
       //  console.log("Validé !");
  }
        } else {
          window.alert("Impossible de valider ce compte car il est déjà validé")
        }
      
      };
       // --- valide un enregistrement ---
      const handleDelete = (DataToEdit: McomptesOperatSysteme | null = null) => {
       setChoix('D')
     if (DataToEdit) { 
         setCurrentDataBranch({ ...DataToEdit })
            form.setFieldsValue({...DataToEdit})
            }; // Copie pour l'édition}
//    alert(currentDataBranch?.UTIVAL)
   if (currentDataBranch?.UTIVAL=="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
         var comptesCommis: McomptesOperatSysteme = {
    IDCODOPE: currentDataBranch?.IDCODOPE || 0,
    CODOPE: currentDataBranch?.CODOPE || '',
    NUMCPT: currentDataBranch?.NUMCPT || '',
     CODAGE: currentDataBranch?.CODAGE || '',
    LIBELL: currentDataBranch?.LIBELL || '',
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: currentDataBranch?.UTIVAL || '',
    DATVAL: currentDataBranch?.DATVAL?.toString() || new Date().toDateString(),
    CHOIX:  'D',


         };
        
          let data = Crypter.encrypt(JSON.stringify(comptesCommis));
         if (window.confirm("Confirmer la suppression de ce compte de groupe?")) {
         
            // alert("yeteooo aaa")
            //alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptOperat,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                                loadAllDataBranch()
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            loadAllDataBranch()
           // SweetAlert.fire({})
        // Action de validation ici
        // console.log("Validé !");
  }
        } else {
          window.alert("Impossible de supprimer ce compte car il est déjà validé")
        }
      
      };
    
    
     
        async function loadAllDataBranch() {
          
             setLoading2(true);
            setError(null);
            try {
            
         // console.log(apiEndpoints.bureaux)
          var params = { CodeAgence: Perss.codage , Table: "COMPTESOPERAT", Colonne1: "CODOPE", Colonne2: "NUMCPT", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
          console.log(params)
          const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
          
          if (data.length!==0)
             {
        // alter(data.result)
          //console.log(data)
          SetDataBranch(normalizeKeysToUppercase(data)); // ou console.log(data)
             }
            }catch (err) {
          console.error("Erreur de chargement:", err);
          setError("Impossible de charger les données .");
         } finally {
          setLoading2(false);
         }
        } ;

    // ====================================================================
    // NOUVEAU FLOW : comptes contrepartie par code operation
    // Choix du CODOPE -> toutes les agences -> selection des comptes GL
    // (deja crees dans COMPTES) avec leur COTE PART en % par agence.
    // Regle : pour chaque agence la somme des cotes part = 100 %.
    // ====================================================================
    interface CompteChoisi {
        numcpt: string;
        nomcpt: string;
        cotepart: number;
        /** true = ligne validee en base (UTIVAL renseigne) : non modifiable. */
        locked: boolean;
    }

    const [codOpeSel, setCodOpeSel] = useState('');
    const [agencesOpe, setAgencesOpe] = useState<{ codage: string; libelle: string; nbComptes: number }[]>([]);
    const [mapComptes, setMapComptes] = useState<Record<string, CompteChoisi[]>>({});
    const [optComptes, setOptComptes] = useState<Record<string, { value: string; label: string; disabled?: boolean }[]>>({});
    const [activeTab, setActiveTab] = useState('1');
    const [listeOperat, setListeOperat] = useState<any[]>([]);
    const [loadingListe, setLoadingListe] = useState(false);
    const [searchOperat, setSearchOperat] = useState('');
    const [selectedOpeKeys, setSelectedOpeKeys] = useState<Key[]>([]);

    const appelCptOperat = async (payload: any): Promise<any> => {
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(`${apiEndpoints.compteRegroup}/GererComptesOperat`, null, {
            headers: { 'CypherGpt': cypher, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        return raw.Value ?? raw;
    };

    const chargerAgencesOpe = async () => {
        const codope = String(form.getFieldValue('CODOPE_GEN') ?? '').trim();
        if (!codope) {
            SweetAlert.fire({ title: 'Code opération requis', icon: 'warning' });
            return;
        }
        setLoading(true);
        try {
            const [resA, resL] = await Promise.all([
                appelCptOperat({ Action: 'AGENCES', CodOpe: codope }),
                appelCptOperat({ Action: 'LISTE', CodOpe: codope })
            ]);
            const ags = resA?.Result?.Table ?? [];
            setAgencesOpe(ags.map((a: any) => ({
                codage: String(a.codage ?? a.CODAGE ?? ''),
                libelle: String(a.libelle ?? a.LIBELLE ?? ''),
                nbComptes: Number(a.nbComptes ?? a.NBCOMPTES ?? 0)
            })));
            const map: Record<string, CompteChoisi[]> = {};
            (resL?.Result?.Table ?? []).forEach((r: any) => {
                const ag = String(r.codage ?? r.CODAGE ?? '');
                const nc = String(r.numcpt ?? r.NUMCPT ?? '');
                if (!ag || !nc) return;
                (map[ag] = map[ag] ?? []).push({
                    numcpt: nc,
                    nomcpt: String(r.nomcpt ?? r.NOMCPT ?? ''),
                    cotepart: Number(r.cotepart ?? r.COTEPART ?? 0),
                    locked: String(r.utival ?? r.UTIVAL ?? '').trim() !== ''
                });
            });
            setMapComptes(map);
            setOptComptes({});
            setCodOpeSel(codope);
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    // Charge les comptes GL de l'agence a l'ouverture de la liste (une fois)
    const chargerComptesAgence = async (codage: string) => {
        if (optComptes[codage]) return;
        try {
            const res = await appelCptOperat({ Action: 'COMPTES', Codage: codage });
            const opts = (res?.Result?.Table ?? []).map((c: any) => {
                const nc = String(c.numcpt ?? c.NUMCPT ?? '');
                return {
                    value: nc,
                    label: `${nc} - ${String(c.nomcpt ?? c.NOMCPT ?? '')}`
                };
            });
            setOptComptes(prev => ({ ...prev, [codage]: opts }));
        } catch (e: any) {
            console.log(e);
        }
    };

    // Ajoute un compte GL a l'agence : cote part pre-remplie avec le reste
    // pour atteindre 100 %.
    const ajouterCompte = (codage: string, numcpt: string) => {
        const opt = (optComptes[codage] ?? []).find(o => o.value === numcpt);
        const nom = opt ? String(opt.label).replace(`${numcpt} - `, '') : '';
        setMapComptes(prev => {
            const lignes = prev[codage] ?? [];
            if (lignes.some(c => c.numcpt === numcpt)) return prev;
            const total = lignes.reduce((s, c) => s + (Number(c.cotepart) || 0), 0);
            const reste = Math.max(0, Math.round((100 - total) * 100) / 100);
            return { ...prev, [codage]: [...lignes, { numcpt, nomcpt: nom, cotepart: reste, locked: false }] };
        });
    };

    const retirerCompte = (codage: string, idx: number) => {
        setMapComptes(prev => {
            const lignes = [...(prev[codage] ?? [])];
            if (lignes[idx]?.locked) return prev;
            lignes.splice(idx, 1);
            return { ...prev, [codage]: lignes };
        });
    };

    const setCotepart = (codage: string, idx: number, v: number) => {
        setMapComptes(prev => {
            const lignes = [...(prev[codage] ?? [])];
            if (!lignes[idx] || lignes[idx].locked) return prev;
            lignes[idx] = { ...lignes[idx], cotepart: v };
            return { ...prev, [codage]: lignes };
        });
    };

    const sommeCoteAgence = (codage: string) =>
        (mapComptes[codage] ?? []).reduce((s, c) => s + (Number(c.cotepart) || 0), 0);

    const enregistrerMapping = async () => {
        if (!codOpeSel) return;
        // Controle front : somme des cotes part = 100 % par agence ayant des comptes
        const agenceKo = agencesOpe.find(a => {
            const lignes = mapComptes[a.codage] ?? [];
            return lignes.length > 0 && Math.abs(sommeCoteAgence(a.codage) - 100) > 0.01;
        });
        if (agenceKo) {
            SweetAlert.fire({
                title: 'Cote part invalide',
                text: `La somme des cotes part de l'agence ${agenceKo.codage} - ${agenceKo.libelle} doit être égale à 100% (actuellement ${sommeCoteAgence(agenceKo.codage)}%).`,
                icon: 'warning'
            });
            return;
        }
        setLoading(true);
        try {
            const items = agencesOpe.map(a => ({
                Codage: a.codage,
                Comptes: (mapComptes[a.codage] ?? []).map(c => ({ Numcpt: c.numcpt, Cotepart: Number(c.cotepart) || 0 }))
            }));
            const res = await appelCptOperat({
                Action: 'ENREGISTRER',
                CodOpe: codOpeSel,
                Utilisateur: Perss.coduti,
                Items: items
            });
            if (res?.StatutCode === 200) {
                SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                chargerAgencesOpe();
                chargerListeOperat();
            } else {
                SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
            }
        } catch (e: any) {
            SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
        }
        setLoading(false);
    };

    const colonnesAgencesOpe = [
        {
            title: 'Agence', width: 230,
            render: (_: any, r: any) => <span><b>{r.codage}</b> — {r.libelle}</span>
        },
        {
            title: 'Comptes GL contrepartie et cote part (%)',
            render: (_: any, r: any) => {
                const lignes = mapComptes[r.codage] ?? [];
                return (
                    <div>
                        {lignes.map((c, i) => (
                            <div key={c.numcpt} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                <Tag color={c.locked ? 'green' : 'blue'} style={{ marginRight: 0 }}>{c.numcpt}</Tag>
                                <span style={{ flex: 1, fontSize: 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {c.nomcpt}
                                </span>
                                <InputNumber
                                    size='small'
                                    min={0} max={100} step={1} precision={2}
                                    style={{ width: 85 }}
                                    value={c.cotepart}
                                    disabled={c.locked}
                                    onChange={(v) => setCotepart(r.codage, i, Number(v ?? 0))}
                                />
                                <Button size='small' danger type='text' disabled={c.locked}
                                    icon={<DeleteIcon style={{ fontSize: 16 }} />}
                                    onClick={() => retirerCompte(r.codage, i)} />
                            </div>
                        ))}
                        <Select
                            size='small'
                            showSearch
                            optionFilterProp='label'
                            style={{ width: '100%' }}
                            placeholder='+ Ajouter un compte GL'
                            value={null}
                            onDropdownVisibleChange={(open: boolean) => { if (open) chargerComptesAgence(r.codage); }}
                            options={(optComptes[r.codage] ?? []).map(o => ({
                                ...o,
                                disabled: lignes.some(c => c.numcpt === o.value)
                            }))}
                            onChange={(v: string) => ajouterCompte(r.codage, v)}
                        />
                    </div>
                );
            }
        },
        {
            title: 'Total', width: 80, align: 'center' as const,
            render: (_: any, r: any) => {
                const lignes = mapComptes[r.codage] ?? [];
                if (lignes.length === 0) return <Tag>—</Tag>;
                const total = sommeCoteAgence(r.codage);
                return <Tag color={Math.abs(total - 100) <= 0.01 ? 'green' : 'red'}>{total} %</Tag>;
            }
        }
    ];

    // ====================================================================
    // LISTE GLOBALE DES COMPTES CONTREPARTIE (onglet 2)
    // Action LISTE de sp_AnyManageComptesOperat sans CodOpe -> toutes lignes
    // ====================================================================
    const chargerListeOperat = async () => {
        setLoadingListe(true);
        try {
            const res = await appelCptOperat({ Action: 'LISTE' });
            setListeOperat(res?.Result?.Table ?? []);
        } catch (e: any) {
            console.log(e);
        }
        setLoadingListe(false);
    };

    useEffect(() => { chargerListeOperat(); }, []);

    // Charge l'operation de la ligne dans le mapping (onglet 1) : exploration
    const explorerOperat = (r: any) => {
        form.setFieldValue('CODOPE_GEN', String(r.codope ?? r.CODOPE ?? ''));
        chargerAgencesOpe();
        setActiveTab('1');
    };

    const validerLigneOpe = (r: any) => {
        const codope = String(r.codope ?? r.CODOPE ?? '');
        const codage = String(r.codage ?? r.CODAGE ?? '');
        const numcpt = String(r.numcpt ?? r.NUMCPT ?? '');
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider le compte ${numcpt} (agence ${codage}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptOperat({ Action: 'VALIDER', CodOpe: codope, Codage: codage, Numcpt: numcpt, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeOperat();
            if (codOpeSel === codope) chargerAgencesOpe();
        });
    };

    const supprimerLigneOpe = (r: any) => {
        const codope = String(r.codope ?? r.CODOPE ?? '');
        const codage = String(r.codage ?? r.CODAGE ?? '');
        const numcpt = String(r.numcpt ?? r.NUMCPT ?? '');
        SweetAlert.fire({
            title: 'Supprimer',
            text: `Supprimer le compte ${numcpt} (agence ${codage}) ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const res = await appelCptOperat({ Action: 'SUPPRIMER', CodOpe: codope, Codage: codage, Numcpt: numcpt, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            chargerListeOperat();
            if (codOpeSel === codope) chargerAgencesOpe();
        });
    };

    // Cle unique d'une ligne de la liste (codope|codage|numcpt)
    const cleLigneOpe = (r: any) =>
        `${r.codope ?? r.CODOPE ?? ''}|${r.codage ?? r.CODAGE ?? ''}|${r.numcpt ?? r.NUMCPT ?? ''}`;

    // Lots (codope + codage) couverts par les lignes cochees
    const lotsSelectionnes = (): { codope: string; codage: string }[] => {
        const pairs = new Map<string, { codope: string; codage: string }>();
        filteredOperat.forEach(r => {
            if (!selectedOpeKeys.includes(cleLigneOpe(r))) return;
            const codope = String(r.codope ?? r.CODOPE ?? '');
            const codage = String(r.codage ?? r.CODAGE ?? '');
            pairs.set(`${codope}|${codage}`, { codope, codage });
        });
        return [...pairs.values()];
    };

    // Valide par lot : une ligne cochee = tout le lot (operation + agence)
    const validerSelection = () => {
        const lots = lotsSelectionnes();
        if (lots.length === 0) return;
        SweetAlert.fire({
            title: 'Valider la sélection',
            text: `Valider ${lots.length} lot(s) opération + agence ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const resu = await Promise.all(lots.map(l =>
                    appelCptOperat({ Action: 'VALIDER', CodOpe: l.codope, Codage: l.codage, Utilisateur: Perss.coduti })
                ));
                const ko = resu.filter(r => r?.StatutCode !== 200);
                if (ko.length === 0) {
                    SweetAlert.fire({ title: 'Succes', text: `${lots.length} lot(s) validé(s)`, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Partiel', text: `${ko.length} lot(s) en erreur : ${ko[0]?.Message ?? ''}`, icon: 'warning' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            setSelectedOpeKeys([]);
            chargerListeOperat();
            if (codOpeSel) chargerAgencesOpe();
        });
    };

    // Supprime par lot : une ligne cochee = tout le lot (operation + agence)
    const supprimerSelection = () => {
        const lots = lotsSelectionnes();
        if (lots.length === 0) return;
        SweetAlert.fire({
            title: 'Supprimer la sélection',
            text: `Supprimer ${lots.length} lot(s) opération + agence ? (les lots contenant des lignes validées seront refusés)`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoadingListe(true);
            try {
                const resu = await Promise.all(lots.map(l =>
                    appelCptOperat({ Action: 'SUPPRIMER', CodOpe: l.codope, Codage: l.codage, Utilisateur: Perss.coduti })
                ));
                const ko = resu.filter(r => r?.StatutCode !== 200);
                if (ko.length === 0) {
                    SweetAlert.fire({ title: 'Succes', text: `${lots.length} lot(s) supprimé(s)`, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Partiel', text: `${ko.length} lot(s) en erreur : ${ko[0]?.Message ?? ''}`, icon: 'warning' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoadingListe(false);
            setSelectedOpeKeys([]);
            chargerListeOperat();
            if (codOpeSel) chargerAgencesOpe();
        });
    };

    // Valide toutes les lignes non validees de l'operation affichee (VALIDER, CodOpe seul)
    const validerOperat = () => {
        if (!codOpeSel) return;
        SweetAlert.fire({
            title: 'Valider',
            text: `Valider tous les comptes contrepartie de l'opération ${codOpeSel} ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#116599',
            cancelButtonColor: 'darkred',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non'
        }).then(async (rep) => {
            if (!rep.isConfirmed) return;
            setLoading(true);
            try {
                const res = await appelCptOperat({ Action: 'VALIDER', CodOpe: codOpeSel, Utilisateur: Perss.coduti });
                if (res?.StatutCode === 200) {
                    SweetAlert.fire({ title: 'Succes', text: res.Message, icon: 'success' });
                } else {
                    SweetAlert.fire({ title: 'Erreur', text: res?.Message ?? 'Echec', icon: 'error' });
                }
            } catch (e: any) {
                SweetAlert.fire({ title: 'Erreur', text: String(e.message ?? e), icon: 'error' });
            }
            setLoading(false);
            chargerListeOperat();
            chargerAgencesOpe();
        });
    };

    // Filtrage de la liste par le champ recherche
    const filteredOperat = listeOperat.filter((r: any) =>
        Object.values(r).some(v => String(v ?? '').toLowerCase().includes(searchOperat.toLowerCase()))
    );

    const colonnesListeOpe = [
        {
            title: 'Opération', dataIndex: 'codope', width: 100,
            sorter: (a: any, b: any) => String(a.codope ?? a.CODOPE ?? '').localeCompare(String(b.codope ?? b.CODOPE ?? ''))
        },
        {
            title: 'Libellé opération', dataIndex: 'libOpe',
            render: (v: any, r: any) => (v ?? r.LIBOPE ?? '—')
        },
        {
            title: 'Agence', dataIndex: 'codage', width: 90,
            sorter: (a: any, b: any) => String(a.codage ?? a.CODAGE ?? '').localeCompare(String(b.codage ?? b.CODAGE ?? '')),
            render: (v: any, r: any) => <span><b>{v ?? r.CODAGE}</b> — {r.libAgence ?? r.LIBAGENCE ?? ''}</span>
        },
        {
            title: 'Compte', dataIndex: 'numcpt', width: 130,
            sorter: (a: any, b: any) => String(a.numcpt ?? a.NUMCPT ?? '').localeCompare(String(b.numcpt ?? b.NUMCPT ?? ''))
        },
        {
            title: 'Intitulé', dataIndex: 'nomcpt',
            render: (v: any, r: any) => (v ?? r.NOMCPT ?? '—')
        },
        {
            title: 'Cote part', dataIndex: 'cotepart', width: 90, align: 'center' as const,
            render: (v: any, r: any) => {
                const c = Number(v ?? r.COTEPART ?? 0);
                return <Tag color='blue'>{c} %</Tag>;
            },
            sorter: (a: any, b: any) => Number(a.cotepart ?? a.COTEPART ?? 0) - Number(b.cotepart ?? b.COTEPART ?? 0)
        },
        {
            title: 'Statut', dataIndex: 'utival', width: 110,
            render: (v: any, r: any) => String(v ?? r.UTIVAL ?? '').trim() !== ''
                ? <Tag color='green'>Validé</Tag>
                : <Tag color='orange'>En attente</Tag>,
            filters: [
                { text: 'Validé', value: 'valide' },
                { text: 'En attente', value: 'attente' }
            ],
            onFilter: (v: any, r: any) => (String(r.utival ?? r.UTIVAL ?? '').trim() !== '') === (v === 'valide')
        },
        {
            title: 'Créé le', dataIndex: 'datcre', width: 100,
            render: (v: any, r: any) => { const d = v ?? r.DATCRE; return d ? new Date(d).toLocaleDateString() : '—'; },
            sorter: (a: any, b: any) => String(a.datcre ?? a.DATCRE ?? '').localeCompare(String(b.datcre ?? b.DATCRE ?? ''))
        },
        {
            title: 'Par', dataIndex: 'utilis', width: 80,
            render: (v: any, r: any) => (v ?? r.UTILIS ?? '—')
        },
        {
            title: 'Validé le', dataIndex: 'datval', width: 100,
            render: (v: any, r: any) => { const d = v ?? r.DATVAL; return d ? new Date(d).toLocaleDateString() : '—'; }
        },
        {
            title: 'Par', dataIndex: 'utival', width: 80,
            render: (v: any, r: any) => { const u = String(v ?? r.UTIVAL ?? '').trim(); return u !== '' ? u : '—'; }
        },
        {
            title: 'Actions', width: 240, fixed: 'right' as const,
            render: (_: any, r: any) => {
                const valide = String(r.utival ?? r.UTIVAL ?? '').trim() !== '';
                return (
                    <Space size={2} wrap>
                        <Button size='small' onClick={() => explorerOperat(r)}>Voir</Button>
                        {!valide && <Button size='small' type='primary' style={{ backgroundColor: '#116599' }} onClick={() => validerLigneOpe(r)}>Valider</Button>}
                        {!valide && <Button size='small' danger onClick={() => supprimerLigneOpe(r)}>Suppr.</Button>}
                    </Space>
                );
            }
        }
    ];

    // Contenu de l'onglet 2 : meme squelette (.border + .bordure1) que l'onglet 1
    const listeContrepartie = (
        <Box fontStyle="inherit" className="border" sx={{ width: '88%', minWidth: 0, boxSizing: 'border-box' }}>
            <legend style={{ textAlign: 'center', paddingLeft: 10, borderRadius: 10 }}>
                Liste des comptes contrepartie par opération
            </legend>
            <fieldset className="bordure1" style={{ width: '99%', boxSizing: 'border-box', marginTop: -20, padding: '16px', minWidth: 0 }}>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            label="Recherche"
                            variant="outlined"
                            fullWidth
                            value={searchOperat}
                            onChange={(e) => setSearchOperat(e.target.value)}
                            size="small"
                            InputLabelProps={{ sx: { fontWeight: 'bold' } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                    {/* Barre d'actions par lot (operation + agence) */}
                    <Box sx={{ mb: 1, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                        <Tag color='geekblue'>Actions par lot (opération + agence)</Tag>
                        <Button size='small' type='primary' style={{ backgroundColor: '#116599' }}
                            disabled={selectedOpeKeys.length === 0}
                            onClick={validerSelection}>
                            Valider la sélection
                        </Button>
                        <Button size='small' danger
                            disabled={selectedOpeKeys.length === 0}
                            onClick={supprimerSelection}>
                            Supprimer la sélection
                        </Button>
                        {selectedOpeKeys.length > 0 && (
                            <Tag>{selectedOpeKeys.length} ligne(s) / {lotsSelectionnes().length} lot(s)</Tag>
                        )}
                    </Box>
                    <AntTable
                        size='small'
                        columns={colonnesListeOpe as any}
                        dataSource={filteredOperat}
                        rowKey={cleLigneOpe}
                        rowSelection={{
                            selectedRowKeys: selectedOpeKeys,
                            onChange: (keys: Key[]) => setSelectedOpeKeys(keys)
                        }}
                        loading={loadingListe}
                        scroll={{ y: 320, x: 'max-content' }}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            pageSizeOptions: [10, 25, 50, 100],
                            showTotal: (t: number) => `${t} ligne(s)`
                        }}
                    />
                </Box>
            </fieldset>
        </Box>
    );

    // 🔁 Gestion du changement de page
      const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
      
      };
    
      // 🔁 Gestion du changement de nombre de lignes
      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Revenir à la première page après changement
      };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UsergroupAddOutlined />
                    Comptes contrepartie par opération
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow', width: '88%' }}  >
                        <Box
                            sx={{
                                // 85% : le panneau Actions (.bG) recouvre la zone a droite de ~89%
                                // minWidth:0 : .tabItem est en display:flex -> sans cela le
                                // contenu large (tableaux) etire le conteneur au lieu de scroller
                                width: '100%',
                                minWidth: 0,
                                boxSizing: 'border-box',
                            }}
                        >
                            <legend style={{ textAlign: "center", paddingLeft: 10, borderRadius: 10 }} > Génération des comptes contrepartie par opération </legend>
                            <fieldset className="bordure1" style={{ marginTop: -20, minWidth: 0 }}>
                                <Grid container spacing={0} alignItems="center">
                                    <Grid item xs={12}>
                                        <SearchModal
                                            disabled={false}
                                            width={0}
                                            Titre="Recherche du code opération"
                                            label="Code opération"
                                            name="CODOPE_GEN"
                                            Taille1={'100%'}
                                            Parametre={searchOperatGen}
                                            Taille2={'100%'}
                                            form={form}
                                            ExecuteafterSelect1={() => chargerAgencesOpe()}
                                        />
                                    </Grid>
                                </Grid>
                            </fieldset>
                            <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                <fieldset className="bordure1" style={{ minWidth: 0 }}>
                                    {agencesOpe.length === 0 ? (
                                        <Box style={{ textAlign: 'center', color: '#999', margin: 16 }}>
                                            Choisissez un code opération puis chargez les agences
                                        </Box>
                                    ) : (
                                        <>
                                            <AntTable
                                                size='small'
                                                columns={colonnesAgencesOpe as any}
                                                dataSource={agencesOpe}
                                                rowKey={(r: any) => r.codage}
                                                pagination={false}
                                                scroll={{ y: 380, x: 'max-content' }}
                                            />
                                            <Box style={{ marginTop: 12, textAlign: 'right' }}>
                                                <Tag color='geekblue' style={{ marginRight: 8 }}>
                                                    La somme des cotes part doit être égale à 100% par agence
                                                </Tag>
                                                <Tag color='orange' style={{ marginRight: 8 }}>
                                                    Les lignes validées ne sont pas modifiables
                                                </Tag>
                                            </Box>
                                        </>
                                    )}
                                </fieldset>
                            </Box>
                        </Box>
                    </div>
                </div >
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <ContactsOutlined />
                    Liste comptes contrepartie
                </span>
            ),
            children: <div className='tabItem'>{listeContrepartie}</div>,
        }
    ];


    // Reinitialise l'ecran : formulaire + etat du mapping contrepartie
    const reinitialiser = () => {
        form.resetFields();
        setAgencesOpe([]);
        setMapComptes({});
        setOptComptes({});
        setCodOpeSel('');
        setSearchOperat('');
        setActiveTab('1');
        setChoix('I');
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                {/* <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}> */}
                 <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>

                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* Recharge la liste + le mapping de l'operation affichee */}
                                <Button size='large' className='bt_add' disabled={loading || loadingListe}
                                    onClick={() => { chargerListeOperat(); if (codOpeSel) chargerAgencesOpe(); }}
                                    type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                {/* Enregistre en masse le mapping de l'operation (onglet 1) */}
                                <Button size='large' className='bt_add' onClick={enregistrerMapping}
                                    disabled={!codOpeSel || agencesOpe.length === 0 || loading}
                                    type="ghost" htmlType="button" block>
                                    Enregistrer
                                </Button>
                                {/* Valide toutes les lignes non validees de l'operation affichee */}
                                <Button size='large' className='bt_add' disabled={!codOpeSel || loading}
                                    onClick={validerOperat}
                                    type="ghost" htmlType="button" block>
                                    Valider
                                </Button>
                                <Button size='large' onClick={reinitialiser} className='bt_add' type="ghost" htmlType="button" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" activeKey={activeTab} onChange={setActiveTab} items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ComptesOperatSysteme;